import { compose, withHandlers } from 'recompose';
import Joi from 'joi-full';
import { formValueSelector } from 'redux-form';
import { INDETERMINATE } from '../../../../../common/constants';
import { phoneErrorMessage, syncValidateDataWithPhone } from '../../../../../common/validator';
import { FORM } from '../constants';
import { withFormName } from '../../../../../common/hoc/withFormName';
import { getFeatureFlags } from '../../../../../../modules/infra/feature-flags';
import { flagNames } from '../../../../../../modules/infra/feature-flags/flags';

export const getSchema = () => {
  const featureFlags = getFeatureFlags();

  const baseSchema = {
    firstName: Joi.string().required().min(2).label('First name'),
    lastName: Joi.string().allow('', null).optional().label('Last name'),
    email: Joi.string().allow('').email({ minDomainAtoms: 2 }).optional().label('Email'),
    instagram: Joi.string().allow('', null).optional().label('Instagram'),
    instagramUserId: Joi.string().allow('', null).optional(),
    color: Joi.string()
      .regex(/^#[A-Fa-f0-9]{3,6}$/)
      .optional(),
    phone: Joi.string()
      .allow('')
      .optional()
      .label('Phone')
      .options({
        language: { string: { regex: { base: phoneErrorMessage } } },
      }),

    requirePasscode: Joi.boolean().optional().allow(null),
    passcode: Joi.when('requirePasscode', {
      is: true,
      then: Joi.string().min(3).max(7).required(),
      otherwise: Joi.string().min(3).max(7).optional().allow(null, ''),
    }),
    username: Joi.when('userEnabled', {
      is: true,
      then: Joi.string().email().required(),
      otherwise: Joi.string().email().optional().allow('', null),
    }),
    hourlyWage: Joi.number().greater(0).optional().allow(null),
    advanceBookDays: Joi.alternatives()
      .try(Joi.any().allow(INDETERMINATE), Joi.number().min(1).max(365).required())
      .label('Book in advance'),
  };

  if (featureFlags[flagNames.HYBRID_STAFF_PAYMENTS_TAB]) {
    baseSchema.depositSettings = Joi.object({
      enabled: Joi.boolean().required(),
    }).required();
  }

  return Joi.object().keys(baseSchema);
};

export const validate = (values) => {
  const dynamicSchema = getSchema();
  return syncValidateDataWithPhone(values, dynamicSchema);
};

export const selector = formValueSelector(FORM);

export const withFormSelector = compose(
  withFormName,
  withHandlers({
    selector:
      ({ form, sectionPrefix }) =>
      (state, fieldName) =>
        formValueSelector(form)(state, `${sectionPrefix ? `[${sectionPrefix}]` : ''}${fieldName}`),
  })
);
